/**
 * Created by pli on 10/9/2016.
 */

var taricCodelistsSearch = angular.module('taric.moreinfo.codelists.search', ['taric.model.codelists', 'common.helper', 'common.filter.description', 'common.filter.specialCharacterToHtml'])
    .controller('SearchCodelistsController', function (CONSTANTS, CodeListsModel, $rootScope, $scope, $state, $stateParams, $translatePartialLoader, $uibModal, $filter, CommonHelper, preferredUILanguages, $translate, $timeout, $location) {
        var searchCodelistsCtrl = this;
        searchCodelistsCtrl.searchCodelistsResult = null;

        searchCodelistsCtrl.resetSearchCodelistsResult = function() {
            searchCodelistsCtrl.searchCodelistsResult = null;
            CodeListsModel.resetSearchResult();
        };

        //Check whether the external parameters are valid or not
        searchCodelistsCtrl.validateExternalParameters = function(){
            return searchCodelistsCtrl.validateSearchForm();
        };

        //Check whether the search form is valid or not
        searchCodelistsCtrl.validateSearchForm = function() {
            searchCodelistsCtrl.handleError();
            return searchCodelistsCtrl.validateSimulationDate() && searchCodelistsCtrl.validateCodeType();
        };

        searchCodelistsCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                searchCodelistsCtrl.errorCode = CommonHelper.validateSimulationDate(searchCodelistsCtrl.searchCriteria.simulationDate);
                if (searchCodelistsCtrl.errorCode){
                    searchCodelistsCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return searchCodelistsCtrl.errorCode === null;
        };

        searchCodelistsCtrl.validateCodeType = function () {
            if (searchCodelistsCtrl.searchCriteria.codeType === null || searchCodelistsCtrl.searchCriteria.codeType === '') {
                searchCodelistsCtrl.errorCode = 'i18n.common.validation.code.type.missing';
            }
            return searchCodelistsCtrl.errorCode === null;
        };

        // Load data for a given page
        searchCodelistsCtrl.loadDataFromServer = function(pageNumber) {
            if (!searchCodelistsCtrl.validateSearchForm()) {
                return;
            }

            // Reset search result before searching
            searchCodelistsCtrl.resetSearchCodelistsResult();
            searchCodelistsCtrl.searching = true;

            if (searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {
                CodeListsModel.queryHtmlCodeTypes().then(function(searchCodelistsResult) {
                    searchCodelistsCtrl.searchCodelistsResult = searchCodelistsResult;
                    searchCodelistsCtrl.searching = false;
                    searchCodelistsCtrl.updateBrowserURL();
                }, function(error){
                    searchCodelistsCtrl.errorCode = error.data.code;
                    searchCodelistsCtrl.errorParams = error.data.params;
                    searchCodelistsCtrl.searching = false;
                });
            } else {
                CodeListsModel.queryAllCodeTypes(pageNumber).then(function(searchCodelistsResult) {
                    searchCodelistsCtrl.searchCodelistsResult = searchCodelistsResult;
                    searchCodelistsCtrl.searching = false;
                    searchCodelistsCtrl.updateBrowserURL();
                }, function(error){
                    searchCodelistsCtrl.errorCode = error.data.code;
                    searchCodelistsCtrl.errorParams = error.data.params;
                    searchCodelistsCtrl.searching = false;
                });
            }
        };

        /**
         * Code lists
         {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/moreinfo/codelists/search?sd={SimulationDate}&ct={CodeType}&l={Language}&ql={QueryLanguage}

         Example:
         http://www.testenv.se/arctictariff-public-web/#!/taric/moreinfo/codelists/search?sd=2015-01-01&ct=MCT&l=en&ql=en
         */
        searchCodelistsCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }
            $location.search({
                sd: CommonHelper.getBookmarkDateString(searchCodelistsCtrl.searchCriteria.simulationDate),
                ct: searchCodelistsCtrl.searchCriteria.codeType,
                ql: searchCodelistsCtrl.searchCriteria.language,
                l : $translate.use()
            }).replace();
        };

        searchCodelistsCtrl.search = function () {
            searchCodelistsCtrl.searchCriteria.ascending = true;
            searchCodelistsCtrl.searchCriteria.sortCol = null;
            // Load data for the first page
            searchCodelistsCtrl.loadDataFromServer();
        };

        // Handle page change for the codelists search result table
        searchCodelistsCtrl.searchCodelistsResultPageChanged = function (pageNumber) {
            searchCodelistsCtrl.loadDataFromServer(pageNumber);
        };

        searchCodelistsCtrl.openDatePicker = function ($event) {
            searchCodelistsCtrl.isDatePickerOpen = true;
        };

        searchCodelistsCtrl.onDateChange = function (dateString) {
            searchCodelistsCtrl.resetError();
            searchCodelistsCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchCodelistsCtrl.searchCriteria.simulationDate, dateString);
            if (searchCodelistsCtrl.searchCriteria.simulationDate) {
                searchCodelistsCtrl.searchCriteria.codeType = '';
                searchCodelistsCtrl.searchCriteria.ascending = true;
                searchCodelistsCtrl.searchCriteria.sortCol = null;
            }
        };

        // View codelists detail
        searchCodelistsCtrl.viewCodelists = function (codelist) {
            CodeListsModel.setSelectedCodelist(codelist);
            searchCodelistsCtrl.searchCriteria.ascending = true;
            searchCodelistsCtrl.searchCriteria.sortCol = null;
            $state.go('taric.moreinfo.codelists.view');
        };

        searchCodelistsCtrl.init = function () {
            searchCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            searchCodelistsCtrl.searchCriteria = CodeListsModel.getSearchCriteria();
            searchCodelistsCtrl.searchCodelistsResult = CodeListsModel.getSearchResult();
            searchCodelistsCtrl.dateFormat = CONSTANTS.dateFormat;
            searchCodelistsCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            searchCodelistsCtrl.languages = preferredUILanguages.items;
            searchCodelistsCtrl.installationCountry = CONSTANTS.installationCountry;
            searchCodelistsCtrl.htmlCodeTypes = [];
            if (CONSTANTS.menu.codeLists.htmlCodeTypes){
                searchCodelistsCtrl.htmlCodeTypes = CONSTANTS.menu.codeLists.htmlCodeTypes;
            }

            // AA-966 If AG code type list is defined, it will be used.
            // Otherwise, the code type list will be empty.
            searchCodelistsCtrl.codeTypes = [];
            if (CONSTANTS.menu.codeLists.agCodeTypes && CONSTANTS.menu.codeLists.agCodeTypes.length > 0) {
                CONSTANTS.menu.codeLists.agCodeTypes.forEach(function(agCodeType){
                    searchCodelistsCtrl.codeTypes.push(agCodeType);
                });
            }

            if (searchCodelistsCtrl.htmlCodeTypes) {
                searchCodelistsCtrl.htmlCodeTypes.forEach(function(htmlCodeType){
                    searchCodelistsCtrl.codeTypes.push(htmlCodeType);
                });
            }

            if (searchCodelistsCtrl.searchCriteria.codeType &&
                    searchCodelistsCtrl.codeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) < 0) {
                searchCodelistsCtrl.searchCriteria.codeType = null;
            }

            searchCodelistsCtrl.searchCriteria.language = CommonHelper.getValidSelectedItem(
                searchCodelistsCtrl.languages,
                searchCodelistsCtrl.searchCriteria.language,
                CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]));

            searchCodelistsCtrl.loadCodeTypes();
            searchCodelistsCtrl.updateCodeType();

            if (searchCodelistsCtrl.isExternalLink() && searchCodelistsCtrl.validateExternalParameters()) {
                // Only auto-search to support bookmark when there are required parameters, and all parameters are valid.
                searchCodelistsCtrl.search();
            }
        };

        searchCodelistsCtrl.isExternalLink = function(){
            return $stateParams.sd && $stateParams.ct;
        };

        searchCodelistsCtrl.loadCodeTypes = function(){
            searchCodelistsCtrl.codeTypeData = [];
            searchCodelistsCtrl.codeTypes.forEach(function(codeType){
                $translate("i8n.common.selectItems.codelist.codetype." + codeType).then(function (codeTypeDescription){
                    searchCodelistsCtrl.codeTypeData.push({
                        "code": codeType,
                        "description": codeTypeDescription
                    });
                }, () => {
                    searchCodelistsCtrl.codeTypeData.push({
                        "code": codeType,
                        "description": "Missing description for code type " + codeType
                    });
                });
            });

            $timeout(function(){

                //Wait for the translation is done and then do a sort
                searchCodelistsCtrl.codeTypeData.sort(function (codeType1, codeType2) {
                    return codeType1.description.localeCompare(codeType2.description,  CommonHelper.getLanguageCode($translate.use()));
                });
            }, 500);

        };

        searchCodelistsCtrl.updateCodeType = function () {
            if (searchCodelistsCtrl.searchCriteria.codeType &&
                searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0) {

                $rootScope.$broadcast('disablePrintable');
                $rootScope.$broadcast('disableExportable');
            } else {
                $rootScope.$broadcast('enablePrintable');
                $rootScope.$broadcast('enableExportable');
            }
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            searchCodelistsCtrl.loadCodeTypes();

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            searchCodelistsCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                searchCodelistsCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        searchCodelistsCtrl.handleError = function(error) {
            if(!error) {
                searchCodelistsCtrl.errorCode = null;
                searchCodelistsCtrl.errorParams = null;
            } else {
                searchCodelistsCtrl.errorCode = error.errorCode;
                searchCodelistsCtrl.errorParams = error.errorParams;
            }
        };

        searchCodelistsCtrl.resetError = function(){
            searchCodelistsCtrl.handleError(null);
        };

        // export excel
        searchCodelistsCtrl.exportExcel = function() {
        	
        	if (!searchCodelistsCtrl.validateSearchForm() ||
                    searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0){
                return;
            }

          	$rootScope.$broadcast('startSpinningExport');

          	// queyr all the data without pagination in the database
          	CodeListsModel.queryAllCodeTypes().then(function(searchCodelistsResult) {

          		var elt = document.getElementById("codeType");
          		var title = elt[elt.selectedIndex].text;
            	var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
            	
            	// extract file name & title from html
            	searchCodelistsCtrl.searchCodelistsAllResult = searchCodelistsResult;
            	document.getElementById('reportDateExtr').innerHTML = reportDate;
            	document.getElementById('reportTitle').innerHTML = title;
            	
            	setTimeout(function(){

            		// columns format of excel
                	var ws = {
                		'!cols': [{
                			wpx: 80
                		}, {
                			wpx: 180
                		}, {
                			wpx: 270
                		}]
                	};
                	
                	// export excel
                	CommonHelper.printExcel("exportExcelTable", title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });
            	}, 1000);
            	
            }, function(error){
                
            	// show errors here
            	searchCodelistsCtrl.errorCode = error.data.code;
                searchCodelistsCtrl.errorParams = error.data.params;
                searchCodelistsCtrl.searching = false;
                
              	$rootScope.$broadcast('stopSpinningExport');
            });
        };
        
        // print pdf
        searchCodelistsCtrl.print = function(options) {

        	if (!searchCodelistsCtrl.validateSearchForm() ||
                    searchCodelistsCtrl.htmlCodeTypes.indexOf(searchCodelistsCtrl.searchCriteria.codeType) >= 0){
                $scope.$apply();
                return;
            }

          	$rootScope.$broadcast('startSpinningPrint');

          	// query all the data without pagination in the database
          	CodeListsModel.queryAllCodeTypes().then(function(searchCodelistsResult) {
            	
          		searchCodelistsCtrl.searchCodelistsAllResult = searchCodelistsResult;
          		
          		// wait for 1s for front end to render the data
            	setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                    
                    // extract report title from html
                    var elt = document.getElementById("codeType");
                	var title = elt[elt.selectedIndex].text;

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: searchCodelistsCtrl.flagImg,
                        eu: searchCodelistsCtrl.euImg,
                        validDate: $filter('date')(searchCodelistsCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: title
                    }, 'p').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);

            }, function (error) {
            	
            	searchCodelistsCtrl.errorCode = error.data.code;
                searchCodelistsCtrl.errorParams = error.data.params;
                searchCodelistsCtrl.searching = false;
              	$rootScope.$broadcast('stopSpinningPrint');
            });
        };

    	$scope.$on('printDocument', function(event, data) {

            // preload EU flag
            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                searchCodelistsCtrl.euImg = options.logo;
            }, true);
    		
    		// preload the logo and national flag of pdf before printing
    		var url = "img/flags/" + searchCodelistsCtrl.installationCountry + ".png";
    		CommonHelper.loadImage(url, 21, 14, function(options) {

    			searchCodelistsCtrl.flagImg = options.logo;
        		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchCodelistsCtrl.print, true);
    		}, true);
        });

    	$scope.$on('exportDocument', function(event, data) {
    		
    		searchCodelistsCtrl.exportExcel();
        });
    });



// WEBPACK FOOTER //
// ./app/taric/moreinfo/codelists/search/codelists-search.js